import React, { useState, useEffect } from "react";
import { video } from "../constants/video";
import { useTranslation } from "react-i18next";

function Video() {
  const { t } = useTranslation("video");
  const [currentVideo, setCurrentVideo] = useState(video[0]);
  const [views, setViews] = useState(0);

  // Load and store view counts in localStorage
  useEffect(() => {
    const storedViews = parseInt(localStorage.getItem(currentVideo.link)) || 0;
    const newViews = storedViews + 1;
    localStorage.setItem(currentVideo.link, newViews);
    setViews(newViews);
  }, [currentVideo]);

  // Format view count (K / M style)
  const formatViews = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + "M views";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K views";
    return num + " views";
  };

  return (
    <div className="w-full max-w-[1400px] mx-auto px-4 py-5">
      {/* Section Title */}
      <div className="text-center mb-8">
        <h2 className="text-2xl uppercase md:text-3xl font-bold text-yellow-500 leading-relaxed">
          {t("video_title")}
        </h2>
      </div>
      {/* Main Layout */}
      <div className="flex flex-col lg:flex-row gap-6 items-start shadow-lg rounded-xl p-4 bg-white/80 backdrop-blur-sm border border-yellow-400">
        {/* Main Video Player */}
        <div className="flex-1 rounded-lg overflow-hidden">
          <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden">
            <iframe
              src={currentVideo.link}
              className="absolute top-0 left-0 w-full h-full border-none"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              allowFullScreen
              title={t(currentVideo.title)}
            ></iframe>
          </div>

          <div className="p-4">
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              {t(currentVideo.title)}
            </h3>
            <p className="text-sm text-gray-500">
              {formatViews(views)} • មែនទិកខាប់ - Mantic Cup
            </p>
            <p className="text-xs text-center text-gray-500 mt-3 italic">
              {t("full_sccreen")}
            </p>
          </div>
        </div>

        {/* Video List */}
        <div className="w-full lg:w-[35%] max-h-[80vh] overflow-y-auto pr-2 space-y-3">
          {video.map((vdo, i) => (
            <div
              key={i}
              onClick={() => setCurrentVideo(vdo)}
              className={`flex items-center gap-3 p-2 border border-yellow-500 rounded-md bg-gray-50 shadow-sm cursor-pointer hover:bg-yellow-100 transition-all ${
                currentVideo.title === vdo.title ? "bg-yellow-200" : ""
              }`}
            >
              <img
                src={vdo.thumbnail}
                alt={t(vdo.title)}
                className="w-28 h-16 object-cover rounded-md border border-gray-300"
              />
              <div>
                <h4 className="text-sm font-medium text-gray-800 line-clamp-2 leading-snug">
                  {t(vdo.title)}
                </h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Video;
